import { supabase } from '../lib/supabaseClient';

export interface PauseParetoPoint {
  reason: string;
  count: number;
  percentage: number;
  cumulativePercentage: number;
}

export async function getPauseReasonPareto(
  organizationId: string,
  days: number,
): Promise<PauseParetoPoint[]> {
  const safeDays = Math.max(days, 1);
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - (safeDays - 1));

  const { data, error } = await supabase
    .from('workflow_tasks_v9')
    .select('pause_reason, updated_at')
    .eq('organization_id', organizationId)
    .not('pause_reason', 'is', null)
    .gte('updated_at', start.toISOString());

  if (error) {
    console.error('Erro ao buscar motivos de pausa:', error);
    return [];
  }

  const pauseMap = new Map<string, number>();
  let total = 0;

  for (const row of data ?? []) {
    const reason = String(row.pause_reason ?? '').trim();
    if (!reason) continue;
    pauseMap.set(reason, (pauseMap.get(reason) ?? 0) + 1);
    total += 1;
  }

  if (total === 0) return [];

  let cumulative = 0;
  return Array.from(pauseMap.entries())
    .map(([reason, count]) => ({
      reason,
      count,
      percentage: (count / total) * 100,
      cumulativePercentage: 0,
    }))
    .sort((a, b) => b.count - a.count)
    .map((item) => {
      cumulative += item.percentage;
      return { ...item, cumulativePercentage: cumulative };
    });
}
